/* eslint-disable
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Cookies from 'js-cookie';
import jstz from 'jstz';

if (!window.BrowserTZone) {
  window.BrowserTZone = {};
}
BrowserTZone.setCookie = () =>
  Cookies.set('browser.timezone', jstz.determine().name(), {
    expires: 365,
    path: '/',
  });

$(() => BrowserTZone.setCookie());
